import { show, toggle } from 'slidetoggle';
import { VacanciesOptions } from './lib-2sxc-vacancies-options';

export function initVacancies({ domId, options } : { domId: string, options: VacanciesOptions }) {
  // get navHight for correct scrollposition
  var nav = (document.getElementsByTagName(options.tagStickyHeader)[0] as HTMLElement);
  var navHeight = (nav != null ? nav.offsetHeight : 0);
  
  let accordionWrapper = document.querySelector(`[${domId}]`)
  
  // attach click to all accordions when loading
  var accordionOpener = accordionWrapper.querySelectorAll(`[${options.attrParent}]`);

  accordionOpener.forEach((elem: HTMLElement) => {	
    elem.addEventListener('click', (event) => {
      event.preventDefault();

      const currentElem = event.currentTarget as HTMLElement;
      const hash = currentElem.dataset.accordionParent.replace('#', '');
      const parent = currentElem.parentElement;
      const targetOpenElem = accordionWrapper.querySelector(`[${options.attrChild}="${hash}"]`) as HTMLElement;		

      // add hash to url
      location.hash = hash;

      // open / close mechanic for slide
      toggle(targetOpenElem, {});
      parent.classList.toggle(`${options.classIsExpanded}`);
    })
  });

  // get hash from url and open specific item
  if(window.location.hash){
    const hash = window.location.hash.replace('#', '');
    const targetHashElem = accordionWrapper.querySelector(`[${options.attrChild}="${hash}"]`);
    
    // if target element exists scroll to element and open it
    if(targetHashElem){
      const elemOffsetX = targetHashElem.getBoundingClientRect().top + window.scrollY - navHeight;
      const targetOpenElem = accordionWrapper.querySelector(`[${options.attrChild}="${hash}"]`) as HTMLElement;		

      targetHashElem.parentElement.classList.add(`${options.classIsExpanded}`);

      // open accordion
      show(targetOpenElem, {
        onAnimationEnd: () => {
          // scroll to element which should open then
          window.scrollTo({
            top: elemOffsetX,
            left: 0,
            behavior: 'smooth'
          });
        }
      });
    }
  }
}
